import { defineNuxtPlugin } from '#app';

// This Nuxt plugin performs the following actions:
// 1. Creates and mounts a component in the DOM to display a loading state.
// 2. Removes the loading component after the page loading is completed.

export default defineNuxtPlugin((nuxtApp) => {
    // Check if the 'document' object and its 'body' property exist.
    if (document && document.body) {
        // Create a 'div' element to display the loading component.
        const loaderHtmlComponent = document.createElement('div');
        // Insert the HTML code for the loading component, specified in the plugin options.
        loaderHtmlComponent.innerHTML = `<!doctype html>
<html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
                outline: 0;
            }

            html,
            body {
                height: 100vh;
                width: 100vh;
                overflow: hidden;
            }

            body {
                overflow: hidden;
                background-color: #262626;
                background-repeat: no-repeat;
                background-position: center center;
                background-attachment: fixed;
                -webkit-background-size: cover;
                background-size: cover;
            }

            .boot-loader {
                width: 100%;
                height: 100%;
                position: fixed;
                z-index: 1000;
                background: #262626;
            }

            .boot-loader__wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 100%;
                min-height: 100%;
                max-width: 1320px;
                margin: 0 auto;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .boot-loader__wrapper > * {
                flex: 0 0 50%;
                max-width: 50%;
            }

            .boot-loader__wrapper--image {
                width: 100%;
            }

            .boot-loader__wrapper--line {
                width: 100%;
                margin: 6rem 0 0;
            }

            .boot-preloader {
                width: 100%;
                height: 10px;
                border-radius: 5px;
                background-color: rgba(255, 255, 255, 0.22);
                position: relative;
                overflow: hidden;
            }

            .boot-preloader--line {
                height: 100%;
                background-color: #6bd7fd;
                position: absolute;
                top: 0;
                left: 0;
                animation: loading 3s linear infinite;
            }

            @keyframes loading {
                0% {
                    width: 0;
                }
                100% {
                    width: 100%;
                }
            }
        </style>
    </head>
    <body>
        <div class="boot-loader">
            <div class="boot-loader__wrapper">
                <div class="boot-loader__wrapper--image">
                    
                </div>
                <div class="boot-loader__wrapper--line">
                    <div class="boot-preloader">
                        <div class="boot-preloader--line"></div>
                    </div>
                </div>
            </div>
        </div>
    </body>
</html>
`;
        // Insert the loading component at the beginning of the document's body.
        document.body.insertBefore(loaderHtmlComponent, document.body.firstChild);

        function removeHTMLComponent() {
            if (loaderHtmlComponent) {
                // Remove the loading component.
                loaderHtmlComponent.remove();
            }
        }

        // Register the 'page:finish' hook to perform actions after page loading is complete.
        nuxtApp.hook('page:finish', () => {
            setTimeout(() => {
                // Remove the loading component.
                removeHTMLComponent();
            }, Number(`2000`));
        });

        // Remove element after fatal error occures
        nuxtApp.hook('app:error', () => {
            // Remove the loading component.
            removeHTMLComponent();
        });
    }
});
